module.exports = __webpack_public_path__ + "img/pay2homelogo.1b47abd9.png";